import React from 'react'
import Img from 'gatsby-image'
import { graphql } from "gatsby"
import classnames from 'classnames'

const Banner = ({ data, credit, creditLeft }) => {
  const { desktop_banner, mobile_banner } = data
  return (
    <div className={classnames('banner', { 'credit-left': creditLeft })}>
      <div className="banner-img desktop">
        <div className="gatsby-image-outer-wrapper">
          <Img
            style={{ maxHeight: "100%", maxWidth: "100%" }}
            imgStyle={{ objectFit: "contain" }}
            fluid={desktop_banner.childImageSharp.fluid} alt="page banner" />
        </div>
        {credit && <span className="credit">Photo: {credit}</span>}
      </div>
      <div className="banner-img mobile">
        <div className="gatsby-image-outer-wrapper">
          <Img
            style={{ maxHeight: "100%", maxWidth: "100%" }}
            imgStyle={{ objectFit: "contain" }}
            fluid={mobile_banner.childImageSharp.fluid} alt="page banner" />
        </div>
        {credit && <span className="credit">Photo: {credit}</span>}
      </div>
    </div>
  )
}

export const query = graphql`
  fragment DesktopBannerSizes on File {
    childImageSharp {
      fluid(maxWidth: 1280, quality: 75) {
        ...GatsbyImageSharpFluid
        ...GatsbyImageSharpFluidLimitPresentationSize
      }
    }
  }
  fragment MobileBannerSizes on File {
    childImageSharp {
      fluid(maxWidth: 768, quality: 75) {
        ...GatsbyImageSharpFluid
        ...GatsbyImageSharpFluidLimitPresentationSize
      }
    }
  }
`

export default Banner
